import React from "react";
import FormGroup from "features/shared/forms/components/FormGroup";
import FormFieldProps from "features/shared/forms/dynamicForm/models/FormFieldProps";
import { useTranslation } from "react-i18next";
import {
  getTranslatedText,
  getTranslatedTooltip,
} from "features/shared/forms/dynamicForm/helpers/dynamicFormHelper";
import DatePicker from "features/shared/components/reactDates/DatePicker";

const DatePickerField = ({ descriptor, formHandler }: FormFieldProps) => {
  // translations
  const t = useTranslation("shared\\dynamicForms").t;

  // form hook props
  const { bindDatePickerField, errors } = { ...formHandler };

  // render
  return (
    <div className={descriptor.className}>
      <FormGroup
        labelText={getTranslatedText(descriptor, "label", t)}
        validationError={errors ? errors[descriptor.name] : undefined}
        tooltip={getTranslatedTooltip(descriptor, t)}
      >
        <DatePicker
          {...bindDatePickerField(descriptor.name)}
          placeholder={getTranslatedText(descriptor, "placeholder", t)}
          onlySelectable
          showYearsSelect
          isClearable
        />
      </FormGroup>
    </div>
  );
};

export default DatePickerField;
